/**
 * Auto-generated lucide icon component.
 *
 * @see https://lucide.dev/icons/menu
 */
import { default as DefaultIcon } from '~icons/lucide/menu';
import { Icon, type IconProps } from 'src/components/media-and-icons/icon';

export const MenuIcon = (props: IconProps) => (
  <Icon icon={DefaultIcon} {...props} />
);
